import Vue from 'vue'
import BaseDetail from './main-detail.vue'
import BaseForm from './main-form.vue'
import BaseTable from './main-table.vue'
import BaseCard from './main-card.vue'
import BaseCRUD from './main-crud.vue'

import compSingleUpload from './component/single-upload'
import compMultiUpload from './component/multiple-upload'
import compLookupInput from './component/lookup-input'
import compLookupAdd from './component/lookup-add'
import compMappingInput from './component/mapping-input'
import compSingleInput from './component/single-input'
import compTableInput from './component/table-input'
import gmaps from './component/gmap.vue'

import approvalSection from '@/base/component/approval-section'

import tableDetail from '@/base/component/table-detail'
import lottieLoading from '@/base/component/lottie-loading'
import statisticCard from '@/base/component/statistic-card'
import loadingProgress from '@/base/component/loading-progress'

import vueExportExcel from '@/base/component/vue-export-excel'

import badge from './component/badge.vue'
import timeline from './component/timeline.vue'

import baseAlert from './component/alert.vue'

import notFound from '../default-page/404.vue'
import ProgressChart from './component/progress-chart.vue'

Vue.component('tas-base-table', BaseTable)
Vue.component('tas-base-card', BaseCard)
Vue.component('tas-base-form', BaseForm)
Vue.component('tas-base-detail', BaseDetail)
Vue.component('tas-base-crud', BaseCRUD)
Vue.component('s-input', compSingleInput)
Vue.component('single-upload', compSingleUpload)
Vue.component('multi-upload', compMultiUpload)
Vue.component('lookup-input', compLookupInput)
Vue.component('lookup-add', compLookupAdd)
Vue.component('mapping-input', compMappingInput)
Vue.component('table-input', compTableInput)
Vue.component('not-found', notFound)
Vue.component('g-maps', gmaps)

Vue.component('approval-section', approvalSection)
Vue.component('table-detail', tableDetail)
Vue.component('lottie-loading', lottieLoading)
Vue.component('statistic-card', statisticCard)
Vue.component('loading-progress', loadingProgress)
Vue.component('progress-chart', ProgressChart)

Vue.component('vue-export-excel', vueExportExcel)

Vue.component('custom-badge', badge)
Vue.component('custom-timeline', timeline)
Vue.component('base-alert', baseAlert)


// WEBPACK FOOTER //
// ./src/base/_base-component.js